import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listResource, createResource, updateResource } from '@diggens/api-client';
import type { Metric } from '@diggens/types';

export function useMetrics(submissionId: string) {
  return useQuery({
    queryKey: ['metrics', submissionId],
    queryFn: async () => {
      const { data } = await listResource<Metric>('metrics', { submission_id: submissionId });
      return data;
    },
    enabled: !!submissionId,
  });
}

export function useCreateMetric() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: Omit<Metric, 'id' | 'created_at' | 'updated_at'>) =>
      createResource<Metric>('metrics', input),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['metrics', data.submission_id],
      });
    },
  });
}

export function useUpdateMetric() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { metricId: string; updates: Partial<Metric> }) =>
      updateResource<Metric>('metrics', variables.metricId, variables.updates),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['metrics', data.submission_id],
      });
      queryClient.invalidateQueries({
        queryKey: ['submission-details', data.submission_id],
      });
    },
  });
}
